import React from "react";
import { Route, Routes } from "react-router-dom";
import { UberEatsDetails, UbereatsList } from "./containers";
import { ProtectedRoute } from "../../shared";

export const Ubereats = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<UbereatsList />} />
        <Route element={<ProtectedRoute allowedRoute={["integration-view"]} />}>
          <Route path="/details/:id" element={<UberEatsDetails />} />
        </Route>
      </Routes>
    </>
  );
};
